import React from 'react';
import { cn } from '../../lib/cn';

const TONES = {
  neutral: 'bg-[#f0f2f5] text-ink-2 border-line',
  ok: 'bg-ok-soft text-ok border-[#cfe9dc]',
  warn: 'bg-warn-soft text-warn border-[#f2dfb9]',
  bad: 'bg-bad-soft text-bad border-[#f4cfca]',
  accent: 'bg-accent-soft text-accent border-[#d6e0ff]',
  dark: 'bg-[#13243f] text-[#c9d4e8] border-white/5',
};

export function Pill({ tone = 'neutral', className, children, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-[2px] rounded-full border text-[11px] font-medium tracking-[0.01em]',
        TONES[tone] || TONES.neutral,
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export default Pill;
